/**
 * Application Configuration
 * Centralized app constants and configuration
 */

export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Consealer'

export const APP_CONFIG = {
  name: APP_NAME,
  // Add more app-wide constants here as needed
}
